import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'components/global/atoms'

const MultipleGroups = ({ meta: { error, touched }, input: { onChange, value }, ...rest }) => (
  <div>
    <Input.MultipleSelect
      {...rest}
      values={value}
      onChange={(v) => onChange(v)}
      error={touched && error && error}
    />
  </div>
)

MultipleGroups.propTypes = {
  meta: PropTypes.shape(),
  input: PropTypes.shape(),
}

export default MultipleGroups
